<template>
    <header :class="['app-header', {fixed: isFixed && !isMobileMenu, 'fixed02': isFixed && isMobileMenu, sp: isMobileMenu}]">
        
        <img v-if="$route.name === 'home' && !isFixed" class="logo pc" src="./images/logo.png" alt="AUBE" style="margin: 0 auto;">
        <img v-if="$route.name !== 'home' && !isFixed" class="logo pc" src="./images/logo_04.png" alt="AUBE" style="margin: 0 auto;">        
        <img v-if="isFixed" class="logo pc" src="./images/logo_01.png" alt="AUBE" style="margin: 0 auto;">
        <img class="logo sp topLayer" src="./images/logo_01.png" alt="AUBE" style="margin: 0 auto;">

        <div v-if="isMobileMenu">
            <div class="knowme-mobile" v-if="typeof $route.name !== 'undefined' && $route.name.indexOf('Order') !== 0">
                <a href="/dna/index.html">
                    <img v-if="isLogged && !isChild" src="./images/knoume_bunner_sp.png" alt="knowme">
                </a>
            </div>
        </div>
        <div v-else class="right">
            <div>
                <ul>
                    <li>
                        <language-choice :isFixed="isFixed"></language-choice>
                    </li>
                </ul>
            </div>
        </div>
        <div class="sp">
            <div class="buttonWrapper">
                <language-choice isFixed></language-choice>
            </div>
        </div>
    </header>
</template>

<script>
    import AuthUtil from '../../utils/AuthUtil';
    import LanguageChoice from '../LanguageChoice/LanguageChoice.vue';
    import UserService from "../../services/UserService";
    
    export default {
        name: 'app-header',

        data() {
            return {
                isFixed: false,
                isMobileMenu: false,
                isOpenMenu: false,
                isLogged: true,
                isChild: true,
                isUrl: '',
            }
        },

        components: {
            LanguageChoice
        },

        async created() {
            this.isLogged = AuthUtil.isAuth();

            if (this.isLogged) {
                this.fetchUserFrontendData();
            }  
        },
        methods: {
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.isChild = data.is_child;
            },
            handleScroll() {
                this.isFixed = this.isMobileMenu || window.scrollY > 10;
	        },

            updateResize() {
                this.isMobileMenu = window.innerWidth <= 991;
            },
        },

        mounted() {
            this.isLogged = AuthUtil.isAuth();
            this.isMobileMenu = window.innerWidth <= 991;
            
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.updateResize);
        },

        destroy() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.updateResize);
        }
    }
</script>

<style scoped>
    .knowme-mobile {
        position: fixed;
        left: 10px;
        bottom: 10px;
    }
    
    .knowme-mobile img {
        width: 70%;
    }
    
    .knowme-mobile a:hover {
        opacity: 70%;
    }
    
    .knowme-pc {
        padding-top: 50px;
    }
    
    .knowme-pc .fixed {
        position: fixed;
        right: 10px;
        top: 10px;
    }

    .knowme-pc img {
        width: 400px;
    }
    
    .knowme-pc a:hover {
        opacity: 70%;
    }

    .app-header .right>div>ul li a register {
        content: "";
        position: absolute;
        left: 0;
        top: 5px;
        background: url(./images/icon_register_black.svg) no-repeat;
        background-size: contain;
        width: 17px;
        height: 15px;
        display: inline-block;
        transition: all .5s ease-out;
    }

    .home .app-header .right div>ul li a register {
        background: url(./images/icon_register_white.svg) no-repeat;
        background-size: contain;
    }

    .app-header.fixed ul li a register {
        background: url(./images/icon_register_black.svg) no-repeat!important;
        background-size: contain!important;
    }

    @media screen and (max-width: 991px){
        #register-sp {
            background: url(./images/icon_register_white.svg) no-repeat;
            background-size: contain;
        }
    }
</style>